import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Admin } from "./Admin";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Portfolio } from "./components/Portfolio";
import { About } from "./components/About";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Toaster } from "react-hot-toast";
import { useState } from "react";

const MainContent = () => {
  const [headerVisible, setHeaderVisible] = useState(false);

  return (
    <div className="min-h-screen">
      <Header isVisible={headerVisible} />
      <main>
        <Hero onHeroLoaded={setHeaderVisible} />
        <About />
        <Contact />
        <Portfolio />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <>
      <Toaster position="top-right" />
      <Router>
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/" element={<MainContent />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
